import { useEffect, useState } from "react"
import Topics from "./topics"
import SubTopics from "./subTopics"
import QuestionOpt from "./questionOption"
import GeneratedQuestions from "./genertedQuestion"
import Lessons from "./lessons"
import QuizDetails from "./quizDetails"
import ApiConfig from "../../../api/ApiConfig"


function CreateBulkAssememtWithAI() {

    const [currentStep, setCurrentStep] = useState(1)
    const initialState = {
        curriculum: '',
        curriculumName: '',
        syllabus: "",
        grade: "",
        subject: '',
        selectedLessons: [],
        selectedSubTopics: [],
        noOfQuestion: 3,
        difficulty: 'easy',
        subjectName: '',
        gradeName: "",
        negative_score : "no",
        number_of_question : 1,
        questionScore: null,
        negativeScore: null,
    }




    const [assessmentDurationState, setAssessmentDurationState] = useState({
        duration_list: [],
      });
      const [selectedAssessmentDuration, setSelectedAssessmentDuration] = useState({
        assessment_duration : null,
        selectedAssessmentDuration: []
      })
      const [selectedAssessmentImprovement, setSelectedAssessmentImprovement] = useState({
        assessment_improvement : null,
        selectedAssessmentImprovement: []
      })

       function onAssessmentImprovementChange(selectedOption) {
    setSelectedAssessmentImprovement({
      ...selectedAssessmentImprovement,
      assessment_improvement: selectedOption.value,
      selectedAssessmentImprovement: selectedOption,
    });
  }

       function onAssessmentDurationChange(selectedOption) {
    setSelectedAssessmentDuration({
      ...selectedAssessmentDuration,
      assessment_duration: selectedOption.value,
      selectedAssessmentDuration: selectedOption,
    });
  }

    const [details, setDetails] = useState(initialState)

    const [topics, setTopics] = useState([])
    const [lessonsIds, setLessonsIds] = useState([])
    const [topicsIds, setTopicsIds] = useState([])


      function getAssessmentDurationList() {
    var assess_duration_list = [];
    for (var i = 2; i <= 36; i++) {
      assess_duration_list.push({ label: i * 5, value: i * 5 });
    }
    setAssessmentDurationState({
      ...assessmentDurationState,
      duration_list: assess_duration_list,
    });
  }

    const handleChange = (key, value) => {

        setDetails(prev => ({
            ...prev,
            [key]: value
        }))

    }

    useEffect(()=>{
         getAssessmentDurationList();
    },[])
   

     
    const validateForm = (
  details,
  selectedAssessmentDuration,
  selectedAssessmentImprovement
) => {
  const errors = {};

  // Fields from details state
  const requiredFields = {
    curriculum: "Curriculum",
    curriculumName: "Curriculum Name",
    grade: "Grade",
    subject: "Subject",
    difficulty: "Difficulty",
    subjectName: "Subject Name",
    gradeName: "Grade Name",
    negative_score: "Negative Score",
    number_of_question: "Number of Questions",
    questionScore: "Question Score",
  };

  // Validate details
  Object.keys(requiredFields).forEach((key) => {
    if (
      details[key] === null ||
      details[key] === "" ||
      details[key] === undefined
    ) {
      errors[key] = `Please select/enter '${requiredFields[key]}'`;
    }
  });

  // Validate negativeScore only if negative_score is "yes"
  if (
    details.negative_score === "yes" &&
    (details.negativeScore === null ||
      details.negativeScore === "" ||
      details.negativeScore === undefined)
  ) {
    errors.negativeScore = "Please select/enter 'Negative Score Value'";
  }

  // Validate assessment duration
  if (
    !selectedAssessmentDuration.assessment_duration &&
    (!selectedAssessmentDuration.selectedAssessmentDuration ||
      selectedAssessmentDuration.selectedAssessmentDuration.length === 0)
  ) {
    errors.assessment_duration =
      "Please select/enter 'Assessment Duration'";
  }

  // Validate assessment improvement
  if (
    !selectedAssessmentImprovement.assessment_improvement &&
    (!selectedAssessmentImprovement.selectedAssessmentImprovement ||
      selectedAssessmentImprovement.selectedAssessmentImprovement.length === 0)
  ) {
    errors.assessment_improvement =
      "Please select/enter 'Assessment Improvement'";
  }

  return errors;
};

    

    return (

        <>
            {
                currentStep === 1 && <QuizDetails validateForm={validateForm} selectedAssessmentImprovement={selectedAssessmentImprovement} onAssessmentImprovementChange={onAssessmentImprovementChange} details={details} selectedAssessmentDuration={selectedAssessmentDuration} onAssessmentDurationChange={onAssessmentDurationChange} assessmentDurationState={assessmentDurationState} handleChange={handleChange} handleNext={setCurrentStep}   isBulk={true}/>
            }
            {
                currentStep == 2 && <Lessons handleNext={setCurrentStep} details={details} handleChange={handleChange} topics={topics} setTopics={setTopics}
                    lessonsIds={lessonsIds} setLessonsIds={setLessonsIds} setTopicsIds={setTopicsIds}
                />
            }

            {
                currentStep === 3 && <SubTopics handleNext={setCurrentStep} details={details} handleChange={handleChange} topics={topics} setTopics={setTopics}
                    topicsIds={topicsIds} setTopicsIds={setTopicsIds}
                />
            }
            {
                currentStep == 4 && <QuestionOpt handleNext={setCurrentStep} details={details} handleChange={handleChange} topics={topics} setTopics={setTopics} />
            }
            {
                currentStep == 5 && <GeneratedQuestions  handleNext={setCurrentStep} details={details} lessonsIds={lessonsIds} topicsIds={topicsIds}
                    setDetails={setDetails} initialState={initialState} setTopics={setTopics} selectedAssessmentDuration={selectedAssessmentDuration}
                    selectedAssessmentImprovement={selectedAssessmentImprovement} isBulk={true}
                />
            }
        </>

    )

}

export default CreateBulkAssememtWithAI